import { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, Stack, Typography } from "@mui/material";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MaterialTypography from "../../../components/MaterialTypography";
import {
  dateFilter,
  dateFilterMange,
  deletetodolist,
  statusFilterList,
  updateTodoList,
} from "./todoData";

import { useLoading } from "../../../context/LodingContext";
import PageLoading from "../../../components/Loading/PageLoading";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Swal from "sweetalert2";
import { MdChangeCircle } from "react-icons/md";
import DateFilter from "../../components/DateFilter";
import RoleAccess from "../../function/RoleAccess";

const TodoListTable = () => {
  const [filter, dispatch] = useReducer(dateFilterMange, dateFilter);
  const [toDoListData, setToDOListData] = useState([]);
  const [value, setValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { setCirleLoading } = useLoading();
  const { userId, userDetails } = useAuthData();
  const navigate = useNavigate();

  const handleChange = async (event, newValue) => {
    setValue(newValue);
    setIsLoading(true);
    const Statusvalue =
      newValue === 0
        ? "To Do"
        : newValue === 1
        ? "In Progress"
        : newValue === 2
        ? "Completed"
        : newValue === 3
        ? "Blocked"
        : "";
    const action = newValue === 4 ? "Public" : "";
    await fetchInduvidualList(
      filter?.formDate,
      filter?.endDate,
      Statusvalue,
      action
    );
    setIsLoading(false);
  };

  const resetFilters = async () => {
    dispatch({ value: "", name: "formDate" });
    dispatch({ value: "", name: "endDate" });
    const Statusvalue =
      value === 0
        ? "To Do"
        : value === 1
        ? "In Progress"
        : value === 2
        ? "Completed"
        : value === 3
        ? "Blocked"
        : "";
    const action = value === 4 ? "Public" : "";

    fetchInduvidualList("", "", Statusvalue, action);
  };

  const toDOListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Heading",
        field: "heading",
        name: "heading",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Content",
        field: "content",
        name: "content",
        flex: 2,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Status",
        field: "status",
        name: "status",
        flex: 2,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Status Date",
        field: "statusDate",
        name: "statusDate",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Create By",
        field: "createdBy",
        name: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Create Date",
        field: "createdAt",
        name: "createdAt",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: toDoListData.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      heading: v?.heading,
      content: v?.content,
      statusDate: v?.statusDate,
      status: (
        <Box
          sx={{
            display: "flex",
            // justifyContent: "space-around",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color:
                v?.status?.toLowerCase() === "to do"
                  ? "#2196F3"
                  : v?.status?.toLowerCase() === "in progress"
                  ? "#FFC107"
                  : v?.status?.toLowerCase() === "completed"
                  ? "#4CAF50"
                  : v?.status?.toLowerCase() === "blocked"
                  ? "#F44336"
                  : "",
            }}
          >
            {v?.status}
          </Typography>
          {(v?.status?.toLowerCase() == "to do" ||
            (v?.status?.toLowerCase() == "in progress" && value != 4)) && (
            <MdChangeCircle
              style={{
                cursor: "pointer",
                color: "grey",
                fontSize: "20px",
                marginLeft: "10px",
              }}
              onClick={() => handleChangeStatus(v?.id, v?.status)}
            />
          )}
        </Box>
      ),
      createdBy: v?.user?.employeeName,
      createdAt: v?.createdAt?.slice(0, 10),
      Action: (
        <div
          style={{
            display: "flex",
            marginTop: "10px",
            alignItems: "center",
          }}
        >
          <RoleAccess modelName="To Do Screen" component="ViewToDo">
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate("/todo/form", {
                  state: { type: "view", rowId: v?.id },
                })
              }
            />
          </RoleAccess>
          <RoleAccess modelName="To Do Screen" component="UpdateToDo">
            {value != 4 && value != 3 && value != 2 && (
              <EditIcon
                fontSize="small"
                className="actionIcon"
                onClick={() =>
                  navigate("/todo/form", {
                    state: { type: "edit", rowId: v?.id },
                  })
                }
              />
            )}
          </RoleAccess>
          <RoleAccess modelName="To Do Screen" component="DeleteToDo">
            {value != 4 && (
              <DeleteIcon
                fontSize="small"
                className="actionIcon"
                onClick={() => handleDelte(v?.id)}
              />
            )}
          </RoleAccess>
        </div>
      ),
    })),
  };

  useEffect(() => {
    callListFunction();
  }, []);

  //fetch induvidual list in only show private
  const fetchInduvidualList = async (
    startDate,
    endDate,
    status,
    action = ""
  ) => {
    setIsLoading(true);
    try {
      const response = await request(BASEURL, statusFilterList, {
        startdate: startDate == "" ? null : startDate,
        enddate: endDate == "" ? null : startDate,
        status: status,
        userid: userId,
        action: action,
      });

      setToDOListData(response?.statusFilterList);
    } catch (error) {
      setToDOListData([]);
    } finally {
      setIsLoading(false);
    }
  };
  // delte function
  const handleDelte = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete this data?",
      text: "This action is irreversible and cannot be recovered.",
      icon: "question",
      showCancelButton: true,
    }).then(async (result) => {
      if (result?.isConfirmed) {
        setCirleLoading(true);
        try {
          const res = await request(BASEURL, deletetodolist, {
            id: id,
          });

          const success = res?.deleteTodoList?.success;
          const message = res?.deleteTodoList?.message;
          if (success) {
            Swal.fire({
              position: "top",
              icon: "success",
              title: message,
              showConfirmButton: true,
            }).then(() => {
              callListFunction();
            });
          } else {
            Swal.fire({
              position: "top",
              icon: "error",
              title: message,
              showConfirmButton: true,
            });
          }
        } catch (err) {
        } finally {
          setCirleLoading(false);
        }
      }
    });
  };

  const handleChangeStatus = async (Id, val) => {
    const { value: status } = await Swal.fire({
      title: "Change Status",
      input: "select",
      inputOptions:
        val?.toLowerCase() == "to do"
          ? {
              InProgress: "In Progress",
              Completed: "Complete",
              Blocked: "Block",
            }
          : {
              Completed: "Complete",
              Blocked: "Block",
            },
      inputPlaceholder: "Select a status",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
          return "You need to select a status!";
        }
      },
    });

    if (status) {
      setCirleLoading(true);
      try {
        const res = await request(BASEURL, updateTodoList, {
          input: {
            id: Id,
            status: status == "InProgress" ? "In Progress" : status,
          },
        });

        const success = res?.updateTodoList?.success;

        if (success) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: "Status Change Successfully",
            showConfirmButton: true,
          }).then(() => {
            callListFunction();
          });
        }
      } catch (err) {
      } finally {
        setCirleLoading(false);
      }
    }
  };

  const handleDateChange = (e, date) => {
    const Statusvalue =
      value == 0
        ? "To Do"
        : value == 1
        ? "In Progress"
        : value == 2
        ? "Completed"
        : value == 3
        ? "Blocked"
        : "";
    const action = value == 4 ? "Public" : "";
    if (e?.target?.value != "") {
      if (date == "endDate") {
        fetchInduvidualList(
          filter?.formDate,
          e?.target?.value,
          Statusvalue,
          action
        );
      } else if (date == "formDate") {
        fetchInduvidualList(
          e?.target?.value,
          filter?.endDate,
          Statusvalue,
          action
        );
      }
    } else {
      fetchInduvidualList(
        filter?.formDate,
        filter?.endDate,
        Statusvalue,
        action
      );
    }
  };

  const exportToCSV = () => {
    const keysToExclude = ["id", "action", "user"];

    // Filter keys (headers)
    const headers = Object.keys(toDoListData[0]).filter(
      (key) => !keysToExclude.includes(key)
    );

    const csvHeader = headers.join(",") + "\n";

    // Build rows with only allowed keys
    const csvRows = toDoListData
      .map((row) => headers.map((header) => row[header]).join(","))
      .join("\n");

    const csvContent = csvHeader + csvRows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "Todo.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Show alert after a brief delay
    setTimeout(() => {
      Swal.fire({
        position: "top",
        icon: "success",
        title: "To Do Excel Download Successfully",
        showConfirmButton: true,
      });
    }, 500); // slight delay to allow download to trigger
  };

  const callListFunction = () => {
    const Statusvalue =
      value == 0
        ? "To Do"
        : value == 1
        ? "In Progress"
        : value == 2
        ? "Completed"
        : value == 3
        ? "Blocked"
        : "";
    const action = value == 4 ? "Public" : "";

    fetchInduvidualList(filter?.formDate, filter?.endDate, Statusvalue, action);
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    {value == 0
                      ? "To Do"
                      : value == 1
                      ? "In Progress"
                      : value == 2
                      ? "Completed"
                      : value == 3
                      ? "Blocked"
                      : "Admin"}{" "}
                    List
                  </MaterialTypography>
                </Stack>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <RoleAccess modelName="To Do Screen" component="ExportToDo">
                    {toDoListData.length > 0 && (
                      <button
                        className="container-btn-file"
                        onClick={exportToCSV}
                        style={{
                          height: "38px",
                          marginLeft: "0",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          fontSize: "14px",
                          marginRight: "20px",
                        }}
                      >
                        <svg
                          fill="#fff"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 50 50"
                        >
                          <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                        </svg>
                        Export File
                      </button>
                    )}
                  </RoleAccess>
                  <RoleAccess modelName="To Do Screen" component="CreateToDo">
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() =>
                        navigate("/todo/form", {
                          state: { type: "add" },
                        })
                      }
                    >
                      To Do
                    </MaterialButton>
                  </RoleAccess>
                </Box>
              </Stack>
              <Box sx={{ marginTop: "5px" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Box sx={{ width: "60%", bgcolor: "background.paper" }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      TabIndicatorProps={{
                        style: {
                          backgroundColor: "#2a9941",
                          color: "white",
                        },
                      }}
                      centered
                    >
                      <Tab label="To Do" />
                      <Tab label="In Progress" />
                      <Tab label="Completed" />
                      <Tab label="Blocked" />
                      {userDetails?.role?.role?.toLowerCase() == "admin" && (
                        <Tab label="Admin" />
                      )}
                    </Tabs>
                  </Box>
                  <Box
                    sx={{
                      width: "40%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <DateFilter
                      dispatch={dispatch}
                      filter={filter}
                      handlefilterChange={handleDateChange}
                      resetFilters={resetFilters}
                    />
                  </Box>
                </Stack>
              </Box>
            </>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={toDOListTable?.rows}
            columns={toDOListTable?.columns}
            isSelectable={false}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No{" "}
                    {value == 0
                      ? "To Do"
                      : value == 1
                      ? "In Progress"
                      : value == 2
                      ? "Completed"
                      : value == 3
                      ? "Blocked"
                      : "Admin"}{" "}
                    found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet add any To Do details. Click on the "Add To
                    Do" button to start adding To Do details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}
        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default TodoListTable;
